import { render, staticRenderFns } from "./BetterUptimeTable.vue?vue&type=template&id=fb9a4d0c&scoped=true"
import script from "./BetterUptimeTable.vue?vue&type=script&lang=js"
export * from "./BetterUptimeTable.vue?vue&type=script&lang=js"
import style0 from "./BetterUptimeTable.vue?vue&type=style&index=0&id=fb9a4d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9a4d0c",
  null
  
)

export default component.exports